import { z } from "zod";
import { playbookIdSchema } from "./playbook.js";
import {
  gradingIdSchema
} from "./teammatePerformanceSummary.js";
const vocalIntelligenceDimensionSchema = z.object({
  score: z.number().min(1).max(5),
  commentary: z.string().min(1)
});
const vocalIntelligenceSchema = z.object({
  // Vocal-delivery dimensions — how the agent sounds.
  authority: vocalIntelligenceDimensionSchema,
  energy: vocalIntelligenceDimensionSchema,
  // Conversational-content dimensions — what the agent says.
  rapport: vocalIntelligenceDimensionSchema
});
const vocalIntelligenceDimensions = [
  "authority",
  "energy",
  "rapport"
];
const perGradingVocalIntelligenceSchema = z.object({
  grading_id: gradingIdSchema,
  analysis: vocalIntelligenceSchema
});
const savedTeammateVocalIntelligenceSchema = z.object({
  generated_at: z.string(),
  // Playbook associated with the gradings. Used to verify if the gradings can be re-used
  playbook_id: playbookIdSchema,
  analysis: vocalIntelligenceSchema,
  // Per-grading analyses that produced this aggregate. The grading IDs in this
  // set are the call set the aggregate was built from, so the aggregation can
  // be reproduced or refreshed against the same calls.
  per_grading_analyses: z.array(perGradingVocalIntelligenceSchema)
});
export {
  perGradingVocalIntelligenceSchema,
  savedTeammateVocalIntelligenceSchema,
  vocalIntelligenceDimensionSchema,
  vocalIntelligenceDimensions,
  vocalIntelligenceSchema
};
//# sourceMappingURL=vocalIntelligence.js.map
